export enum TripCategory {
  LUXURY = 'Luxury',
  ROMANCE = 'Romance',
  FUN = 'Fun',
  CUSTOM = 'Custom',
}

export enum TripFocus {
  TOP_RATED = 'Top Rated',
  POPULAR = 'Popular',
}

export const tripCategoryOptions = [TripCategory.LUXURY, TripCategory.ROMANCE, TripCategory.FUN, TripCategory.CUSTOM];
export const tripFocusOptions = [TripFocus.TOP_RATED, TripFocus.POPULAR];

// TODO remove when we have api for this
export const tripCategoryTagsList = {
  [TripCategory.LUXURY]: [
    {
      id: '4cab4fc5-8135-32e6-b756-7debad0576f8',
      name: 'First',
      domain: 'TRANSPORTATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '937c597d-7957-3a57-b666-3b421274fdbd',
      name: 'Business',
      domain: 'TRANSPORTATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'ece70f3e-9630-3c8e-8ec6-73f200a8b445',
      name: 'Non-stop',
      domain: 'TRANSPORTATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '6ecef8fa-9ae4-35b6-ac59-a05d3ff60ace',
      name: 'Castle',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '4a3e9d49-bce9-375d-ab5b-bb6a63346afc',
      name: 'Massage & Spa',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '1a27cba4-a08d-39da-986c-2e247cc4586d',
      name: 'In-Room Fireplace',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '71d57d32-ff3a-3eb5-8e28-e434478d0d67',
      name: 'On-Site Spa',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '61dbd927-80c5-3aca-963b-9742e172795d',
      name: 'Private Plunge Pool',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'cd5e21df-c933-3736-bb4d-c5a4a94cfcaa',
      name: 'Top Rated 5%',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '0014a49f-bd61-35f8-a960-03040f6c9508',
      name: '5* Hotel',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '43740436-90fd-392f-b0d1-26e3972c8611',
      name: 'Villa',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'daf53070-10cb-366a-91ac-8d0c10fb8f1d',
      name: 'Palace',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'c9a71031-015e-3f01-b147-bf6f1dadfa87',
      name: 'Golf',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '297acd15-41e9-36fe-8d1c-2aa4fae85426',
      name: 'Luxury Shopping',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '4c46ef4d-c065-3c97-a95c-62aace26e873',
      name: 'Live Theater',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'fdf2994e-d591-3aa9-a747-337cb502923a',
      name: 'Four Seasons',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '9612a876-0804-3244-96b7-ff6e11b02733',
      name: 'Mandarin Oriental Hotel Group',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'cf0f35af-e975-34c1-987b-4a90fe4dba1d',
      name: 'Rosewood Hotels',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '0115e0e4-2936-30f8-b19a-67cd07833594',
      name: '$$$$',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'fabcb0e0-e0d7-301d-b9c1-209dcee5d7d1',
      name: 'Michelin 3*',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '3dc7591d-9de5-3aa6-afda-356d07a6d19c',
      name: 'Michelin 2*',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '5f80a498-37bb-3664-860d-f6be2e67bf64',
      name: 'Michelin 1*',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '4725b35e-ba42-319c-9dfc-354e87d578f1',
      name: "Travelers' Choice 2020",
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '58556bdc-9d1a-38de-862b-9561352f3303',
      name: 'Art Galleries',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '0155423a-5d41-36a7-b0b4-5346900d9984',
      name: 'Watches',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'd38180fc-bfb3-32ed-afa2-079a22166501',
      name: 'Spas',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '7005e4cf-d5db-3133-8c0e-648e86816750',
      name: 'Helicopter',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '2e7fa0f5-4b6c-3fee-8f71-678a7a1e869a',
      name: 'Waterskiing & Jetskiing',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '028bb116-d2c1-31f4-aa98-ab3be5ef4033',
      name: 'Glamping',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '141838ff-522c-3dd5-b581-ba51bb6b9b4f',
      name: 'Over Water Bungalow',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'f6fd5256-2fe1-3c58-88e3-9d584d9e4d2b',
      name: 'Yacht',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '2d0fa72f-c89f-3d23-8f79-36a4d1d4bc4b',
      name: 'Egyptian Cotton or Frette Sheets',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '5e578d5f-40f1-38e2-b431-e33d9b5dd42e',
      name: 'Bed & Breakfast',
      domain: 'ACCOMMODATION',
      domainSection: 'Places',
      value: true,
    },
    {
      id: '97d77f6d-6d06-3d78-a2b4-77111ab76999',
      name: 'Catamaran',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '24582ccd-ed7f-3cfe-884a-6760a9260116',
      name: 'Falconry',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '780d411a-65ec-3379-80df-99cb864eca96',
      name: 'Heli-Hiking',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '05a44b1b-5740-3c42-89ee-207c90e294a7',
      name: 'Cashmere',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
  ],
  [TripCategory.ROMANCE]: [
    {
      id: 'ece70f3e-9630-3c8e-8ec6-73f200a8b445',
      name: 'Non-stop',
      domain: 'TRANSPORTATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'f865a583-5ceb-3d21-8d6e-9c90cf2adb8d',
      name: 'Safari / Tentalow',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'c30b8390-33b9-32c5-a400-fa664216d943',
      name: 'Villa',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '16d14440-210e-34e0-ae3d-fb55dac5aeb7',
      name: 'Infinity Pool',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '1a27cba4-a08d-39da-986c-2e247cc4586d',
      name: 'In-Room Fireplace',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '8c9bca29-5dcf-33eb-941c-793b1043bbcc',
      name: 'Sauna',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '6d1bd62a-0fb4-351b-a483-98fd9c3334d9',
      name: 'Sauna',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '79a4bb36-7662-32e8-8070-5f5cc61555de',
      name: 'Top 1% Highest Rated in City',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '7897f9c9-6173-3c61-8aa9-4c36657e72db',
      name: 'Bakery',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '9a90093e-9535-3b2e-b5d2-69f7be3fe558',
      name: 'Breweries',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '7f3119de-188a-3796-80fe-47a3286ab1e1',
      name: 'Chocolate cake',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '5aafc837-7fbe-3a95-a89f-45f8eb7cbaa6',
      name: 'Steakhouse',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'd38180fc-bfb3-32ed-afa2-079a22166501',
      name: 'Spas',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '18c3bfa3-f1bf-30be-9ad4-a78a18e2969f',
      name: 'Thermal Pools',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'f7ee8274-ed11-3301-ba12-b34a1113e181',
      name: 'Dance',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '79a4bb36-7662-32e8-8070-5f5cc61555de',
      name: 'Indoor Sky Diving',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '88b95b36-0579-3033-9dcd-d2416b49f429',
      name: 'National Parks',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'e7d16a40-e0c6-383b-ae76-9234f994d595',
      name: 'Rock climbing',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '9a5dddd1-13d4-3c47-86a4-73fec8e7523a',
      name: 'Scuba',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      name: 'Chalet',
      id: '576e0ed5-cb9d-3a42-83d8-5387fdb7181b',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      name: 'Cottage',
      id: '1e28fb38-4234-3dd1-94d7-be2dd4ccb9b4',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      name: 'Over Water Bungalow',
      id: '141838ff-522c-3dd5-b581-ba51bb6b9b4f',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      name: 'Riad',
      id: '5b275fc8-5a66-3a47-820b-945e43d8381a',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      name: 'Tree House',
      id: '1fc2dcfa-854a-35b2-bbc6-aeb7191922ce',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      name: 'Bed & Breakfast',
      id: '5e578d5f-40f1-38e2-b431-e33d9b5dd42e',
      domain: 'ACCOMMODATION',
      domainSection: 'Places',
      value: true,
    },
    {
      name: 'Glass Blowing',
      id: 'bc502f05-92a0-31fa-818a-f6df7a172a18',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      name: 'Aurora Borealis',
      id: '52f0c41c-fae5-3df3-9eea-aafe26d455ca',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      name: 'Bungee Jumping',
      id: '05b905d8-06fe-3d15-a312-0e25e10462ec',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      name: 'Falconry',
      id: '24582ccd-ed7f-3cfe-884a-6760a9260116',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
  ],
  [TripCategory.FUN]: [
    {
      id: 'ece70f3e-9630-3c8e-8ec6-73f200a8b445',
      name: 'Non-stop',
      domain: 'TRANSPORTATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'c30b8390-33b9-32c5-a400-fa664216d943',
      name: 'Villa',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '9ffe5068-4bc0-3ab5-93cb-46465eac0063',
      name: 'Waterslide',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '7c1096fd-3364-36d4-8b4b-f6c60e6ba5fe',
      name: 'Bathtub',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '4e6a4819-10b1-391c-9186-4b249e19d5e2',
      name: 'Ski-In / Ski-Out',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '850904d5-b15e-3f9f-a33b-b58cc34b8c41',
      name: 'Chilli Crab',
      domain: 'DINING',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '5c2ab243-e192-35c3-adf0-34c1b14ee54d',
      name: 'Street Food',
      domain: 'DINING',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'ec5658bb-c169-39c1-acc8-6b735db89f28',
      name: 'Nightclub',
      domain: 'ENTERTAINMENT',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'dce17b4f-bbd3-370a-aa64-ad9612668b98',
      name: 'Live Music',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'becfa06c-1e64-3881-8067-7a62c5af50ca',
      name: 'Night Market',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'd51f735b-e345-38c2-951a-7d46942b14cc',
      name: 'Escape room',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'eb7b2f85-043e-33ec-a080-7e5d3182ceee',
      name: 'Flight Simulator',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'f295cf21-37a9-34e9-8ec7-1eac0dc14bd9',
      name: 'Laser Tag',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'd95d74dc-ee55-30c8-8c85-d9c113cc8b32',
      name: 'Cave',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '8bd53c3d-7c3a-3928-b5bb-7b43c61371f7',
      name: 'Caverns & Caves',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '3466bdeb-efc3-3da0-9abe-001afc3b7961',
      name: 'Water Park',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '9dbc7b3f-0fb3-31af-876b-a89a831a78e6',
      name: 'Water Parks',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '7005e4cf-d5db-3133-8c0e-648e86816750',
      name: 'Helicopter Tours',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '35e48b03-a60b-3fa4-a320-0c48bf2f828a',
      name: 'Air Tours',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '4c24106a-7416-3bc2-b569-bcd4742ebe9b',
      name: 'River Rafting & Tubing',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '1104b675-7cf4-3bdb-9bd0-58a5818dc3a9',
      name: 'Paragliding',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '372ce9c9-6af6-34dd-a29e-1a93fcd74370',
      name: 'Grass Roof',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'aa96f65f-3617-391a-a04c-eeaabb5705aa',
      name: 'Ice Hotel',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '5c2ab243-e192-35c3-adf0-34c1b14ee54d',
      name: 'Street Food',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'd6a94694-d5e9-3fe2-b392-9fb548ac4207',
      name: 'Bioluminescence',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '4c24106a-7416-3bc2-b569-bcd4742ebe9b',
      name: 'River Rafting & Tubing',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '8bd53c3d-7c3a-3928-b5bb-7b43c61371f7',
      name: 'Caverns & Caves',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '35e48b03-a60b-3fa4-a320-0c48bf2f828a',
      name: 'Air Tours',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '7005e4cf-d5db-3133-8c0e-648e86816750',
      name: 'Helicopter Tours',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '9dbc7b3f-0fb3-31af-876b-a89a831a78e6',
      name: 'Water Parks',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
  ],
  [TripCategory.CUSTOM]: [],
};

export const tripFocusTagList = {
  [TripFocus.TOP_RATED]: [
    {
      id: 'c658ce43-f09d-3a42-9747-29af11c459ff',
      name: 'JetBlue',
      domain: 'TRANSPORTATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'f7124242-02ae-32b7-b642-2ce8683cf4b8',
      name: 'Delta',
      domain: 'TRANSPORTATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '7ae54ff8-abb7-37d8-b3cc-327610679487',
      name: 'United',
      domain: 'TRANSPORTATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'cd5e21df-c933-3736-bb4d-c5a4a94cfcaa',
      name: 'Top Rated 5%',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'f2ee29cd-86f0-3ab6-91b6-eeb377960628',
      name: 'Top Rated 5%',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '0014a49f-bd61-35f8-a960-03040f6c9508',
      name: '5* Hotel',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '0b365633-53a3-3364-9fe3-67db2d71465c',
      name: '4* Hotel',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'e36534f0-8557-394f-9b78-908e98dd22c2',
      name: 'Top Rated 5%',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'fabcb0e0-e0d7-301d-b9c1-209dcee5d7d1',
      name: 'Michelin 3*',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '3dc7591d-9de5-3aa6-afda-356d07a6d19c',
      name: 'Michelin 2*',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'd51f735b-e345-38c2-951a-7d46942b14cc',
      name: 'Escape room',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '2fec9a98-65a8-3032-a5ea-de2d26080b58',
      name: 'Room Escape Games',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'be4a2652-fb42-3268-9365-3f32edb17a71',
      name: 'Escape Rooms',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '4a3e9d49-bce9-375d-ab5b-bb6a63346afc',
      name: 'Massage & Spa',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: 'e57c83a9-1712-3df8-bd9d-1b98e2410b84',
      name: 'In-Room Massage',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '799083f6-8161-3ba6-883b-348842bb7b59',
      name: 'Spa / Massage',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '4845b554-b05a-3ffa-bed7-d3b385803e0b',
      name: 'Massage & spa',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
  ],
  [TripFocus.POPULAR]: [
    {
      id: 'fee59c1b-3b3e-3d9c-a411-9ed906adc25d',
      name: 'Top Rated 10%',
      domain: 'ACCOMMODATION',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '3ee55415-ff9c-3ef2-af9f-1469ae0bfc55',
      name: 'Top Rated 10%',
      domain: 'DINING',
      domainSection: 'Types',
      value: true,
    },
    {
      id: '7bf8a900-cf72-3874-8c3a-ba8f3bb48e70',
      name: 'Top Rated 10%',
      domain: 'EXPERIENCE',
      domainSection: 'Types',
      value: true,
    },
  ],
};
